<template>
  <div class="ren-decoration-cp ren-decoration-cp-member-card">
    <div>
      <strong>{{ title }}</strong>
      <span>{{ subtitle }}</span>
    </div>
    <i>{{ loginButtonText }}</i>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '会员中心'))
const subtitle = computed(() => stringValue(props.component.props?.subtitle))
const loginButtonText = computed(() => stringValue(props.component.props?.loginButtonText, '登录 / 注册'))
</script>
